module.exports = __webpack_public_path__ + "static/img/5.bd245cf7.png";